// VERY IMPORTANT!
// Make sure you use descriptive names in the strings, otherwise there will be name clashes.
// In other words, we cannot re-use a name inside a string inside another redux component

export const SET_USER_ACCOUNTS = "SET_USER_ACCOUNTS";
